module.exports = __webpack_public_path__ + "img/detail-quality-2.d15536d3.png";